import { render, staticRenderFns } from "./AscMxRecTitleWrapper.vue?vue&type=template&id=34224414&"
import script from "./AscMxRecTitleWrapper.vue?vue&type=script&lang=js&"
export * from "./AscMxRecTitleWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscMxRecTitleWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
